import React, { ReactElement } from 'react'
import { CARBON_LABEL } from '@mindfulchefuk/constants'
import { logCarbonLabelClick } from '@mindfulchefuk/utils/analytics'
import { Flex, Link, Text, theme } from '@mindfulchefuk/design-system'

type TRecipeStatLowCarbon = {
  /** Only used for analytics, everything else is identical */
  variant: 'details' | 'card'
}

export const RecipeStatLowCarbon = ({
  variant,
}: TRecipeStatLowCarbon): ReactElement => {
  return (
    <Flex direction="row" alignItems="center">
      <Text variant="body-md" color={theme.colors['pepper-500']} mr={10}>
        {CARBON_LABEL}
      </Text>

      <Link
        target="_blank"
        href="https://www.mindfulchef.com/lowcarbonrange"
        onClick={(e) => {
          logCarbonLabelClick(variant)
          e.stopPropagation()
        }}
        variant="body-xs-500"
      >
        Learn more
      </Link>
    </Flex>
  )
}
